<template>
<div class="myheader-contain">
    <div
    class="myheader layout_header layout_parent"
    v-if="$store.state.myRender.common.header_display === 'true'"
    :style="{
      backgroundColor: h_b.radio_val !== 'hidden' ? h_b[h_b.radio_val].color : '',
      backgroundImage:h_b.radio_val !== 'hidden' && h_b[h_b.radio_val].img !== '' ? 'url('+h_b[h_b.radio_val].img+')' : 'none',
      backgroundSize: h_b[h_b.radio_val].background_size,
      backgroundRepeat: h_b[h_b.radio_val].background_repeat,
      backgroundPosition: h_b[h_b.radio_val].background_position,
    }"
  >
    <fixed_background_layer v-if="$store.state.myRender.common.fixed_height === 'all'"></fixed_background_layer>
    <!-- <div class="fixed_header_mongolia" @click="row_edit_close"></div> -->
    <template v-if="!mbHeaderVisible">
      <layout_row
        v-for="(val,i) in $store.state.myRender.header"
        :row="val"
        :row_index="i"
        :key="val.widgets_id"
      ></layout_row>
    </template>
    <template v-else>
      <mobile_header v-if="$store.state.myRender.header.length > 0" :style="mobileHeaderPositionStyle"></mobile_header>
      <div v-if="isPC" class="height-placeholder" style="height: 50px;"></div>
    </template>
  </div>
</div>
</template>

<script>
import mobile_header from '@/widgets/mobile_header/index.vue'
import layout_row from '@/widgets/layout_row/index.vue'
import fixed_background_layer from '@/components/fixed_background_layer'

export default {
  name: 'myheader',
  components: {
    layout_row,
    mobile_header,
    fixed_background_layer
  },
  data() {
    return {
      mbHeaderVisible: this.$store.state.app.view_pattern === 'mb'
    }
  },
  computed: {
    isMB() {
      return this.$store.state.app.view_pattern === 'mb'
    },
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    h_b() {
      return this.$store.state.myRender.common.header_background
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    mobileHeaderPositionStyle() {
      // 处理新增需求-顶部最小宽度设置，mbheader显示在 pc view pattern下
      if (!this.isMB && this.mbHeaderVisible) {
        return {
          position: 'fixed',
          top: '72px',
          left: 0,
          'z-index': 1998,
          width: '100%',
        }
      }
    },
  },
  watch: {
    '$store.state.myRender.header'(val) {
      //顶部固定初始化
      if (val.length > 0) {
        this.$nextTick(() => {
          this.templet.fixed_init()
        })
      }
    },
    '$store.state.myRender.common.header_display'(val) {
      setTimeout(() => {
        if (this.isFullPage) {
          this.handleHeaderType()
        }
      })
    },
    '$store.state.app.view_pattern'(val) {
      this.setMbHeaderVisible()
    },
    '$store.state.myRender.common.nav_min_width': {
      deep: true,
      handler() {
        this.setMbHeaderVisible()
      }
    }
  },
  methods: {
    row_edit_close() {
      this.templet.row_Mongolia_close();
      this.templet.main_dialog_reset();
    },
    handleHeaderType() {
      let headerIsZhanwei = this.$store.state.myRender.private.fullPageTopNavType === 'zhanwei'
      if (!headerIsZhanwei) {
        $('.myheader').addClass('header-xuanfu')
      } else {
        $('.myheader').removeClass('header-xuanfu')
      }
      let headerIsFixed = String(this.$store.state.myRender.common.fixed_header) === 'true'
      let fullPageCurrentIndex = this.$store.state.app.fullPageCurrentIndex
      if (!headerIsFixed && fullPageCurrentIndex !== 0) {
        $('.myheader').hide()
      } else {
        $('.myheader').show()
      }
    },
    bind() {
      $(window).on('resize', () => {
        this.setMbHeaderVisible()
      })
    },
    setMbHeaderVisible() {
      let mbHeaderVisible
      if (this.$store.state.myRender.common.nav_min_width) {
        mbHeaderVisible = this.isMB || $(window).width() < this.$store.state.myRender.common.nav_min_width[this.$store.state.myRender.common.nav_min_width.radio_val].val
      } else {
        mbHeaderVisible = this.isMB
      }
      if (this.mbHeaderVisible !== mbHeaderVisible) {
        this.mbHeaderVisible = mbHeaderVisible
      }
    }
  },
  mounted() {
    this.setMbHeaderVisible()
    this.bind()
  }
}
</script>



// WEBPACK FOOTER //
// src/view/public/header.vue